import TableWithHandlers from './tableWithHandlers';

export default TableWithHandlers;
